import { AvailabilityReport } from "@/components/availability/AvailabilityReport";
import type { AvailabilitySearch } from "@/components/availability/search-params";
import { PageContainer } from "@/components/shared/PageContainer";

interface AvailabilityPageProps {
  search: AvailabilitySearch;
  onSearchChange: (next: AvailabilitySearch) => void;
}

/** Reports → Availability. Open to every role; it is read-only. */
export function AvailabilityPage({ search, onSearchChange }: AvailabilityPageProps) {
  return (
    <PageContainer>
      <AvailabilityReport search={search} onSearchChange={onSearchChange} />
    </PageContainer>
  );
}
